import script from "./topheader.vue?vue&type=script&setup=true&lang=js"
export * from "./topheader.vue?vue&type=script&setup=true&lang=js"

import "./topheader.vue?vue&type=style&index=0&id=295ace62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295ace62"]])

export default __exports__